<template>
  <div class="contenedor">
    <AmountSelector
      v-model="amount"
      :amounts="amounts"
      :currency="currency"
      :disabled="isLoading"
      :show-error="showError"
      @amount-selected="handleAmountSelected"
    />
    
    <!-- Mostrar el botón de depósito o el spinner si se está procesando -->
    <button 
      class="deposit" 
      @click="submitDeposit" 
      :disabled="isLoading || amount < 50"
    >
      <span v-if="isLoading">Processing...</span>
      <span v-else style="color:black">Deposit</span>
    </button>
  </div>
</template>

<script>
import AmountSelector from './AmountSelector.vue';

export default {
  name: 'DepositForm',
  components: {
    AmountSelector
  },
  props: {
    username: {
      type: String,
      required: true
    },
    amounts: {
      type: Array,
      default: () => [50, 100, 200, 300, 500, 700, 1000, 1500, 2000, 3000, 5000, 10000, 20000, 50000, 100000, 150000, 200000, 250000, 300000, 500000]
    },
    currency: {
      type: String,
      default: 'MWK'
    },
    apiUrl: {
      type: String,
      required: true
    }
  },
  emits: ['deposit-submitted', 'deposit-success', 'deposit-error'],
  data() {
    return {
      amount: null,
      showError: false,
      isLoading: false
    };
  },
  methods: {
    validateAmount() {
      this.showError = this.amount !== null && this.amount < 50;
    },
    async handleAmountSelected(value) {
      this.amount = value;
      this.showError = false;
      await this.submitDeposit();
    },
    async submitDeposit() {
      if (this.amount < 50) {
        this.showError = true;
        this.$emit('deposit-error', "Amount must be at least 50 MWK.");
        return;
      }

      this.isLoading = true;
      this.$emit('deposit-submitted');

      const data = {
        username: this.username,
        amount: this.amount,
      };

      try {
        const response = await fetch(`${this.apiUrl}/api/deposit/mobile/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();
        //alert("Voy por aqui");
        //console.log(result);
        if (!response.ok) {
          throw new Error(result.message || "Unknown error occurred");
        }

        // Verificar si la respuesta fue exitosa basándonos en el código
        if (result.code === 0) {
          //alert(result.data.status_code);
          // Si la respuesta es exitosa, mostrar el componente OTP
          
            let message = "<h2>" + result.data.description + "</h2>";
            message += "Reference: " + result.data.external_transaction_id;
            this.$emit('deposit-success', message);
          
        } else {
          this.$emit('deposit-error', "Deposit failed: " + result.message);
        }
        
      } catch (error) {
        console.error("Error submitting deposit:", error);
        this.$emit('deposit-error', error.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    amount() {
      this.validateAmount();
    }
  }
};
</script>

<style scoped>
.contenedor {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  display: inherit;
  background-color: #e7e7e7;
  align-content: center;
  justify-items: center;
}

.deposit {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  min-width: 275px;
  margin-top: 10px;
  padding: 10px 20px;
  cursor: pointer;
  color: black;
  background-color: #cddc39;
  border: 2px solid #cddc39;
  border-radius: 6px;
  transition: background-color 0.3s ease;
}

.deposit:hover:not(:disabled) {
  border: 2px solid #0e9e29;
  background-color: #b7dc39;
}

.deposit:disabled {
  cursor: not-allowed;
  background-color: #ccc;
}
</style>
